import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "success-login col-hvcenter"
}
const _hoisted_2 = { class: "col-hvcenter content" }
const _hoisted_3 = { class: "logo-img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "timer" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")

  return ($data.int)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: '/' + $data.int.logo
            }, null, 8 /* PROPS */, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createTextVNode(" You have connected your ")),
            _createElementVNode("b", null, _toDisplayString($data.int.name), 1 /* TEXT */),
            _cache[1] || (_cache[1] = _createTextVNode(" account "))
          ]),
          _createVNode(_component_Button, {
            primary: "",
            class: "btn",
            onClick: $options.onClose
          }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createTextVNode(" Close ")),
              _createElementVNode("div", _hoisted_6, "(" + _toDisplayString($data.timer) + ")", 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}